// extracted by mini-css-extract-plugin
module.exports = {"center_buttons":"TableComponent_center_buttons__3Gl02"};